import React from 'react';

export function SkeletonText({ width = '100%', count = 1 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-text" style={{ width }} />
      ))}
    </>
  );
}

export function SkeletonCircle({ size = 40 }) {
  return <div className="skeleton-circle" style={{ width: size, height: size }} />;
}

export function SkeletonBlock({ width = '100%', height = 80 }) {
  return <div className="skeleton-block" style={{ width, height }} />;
}

// Generic table-row skeleton for list pages — pass the column count to match.
export function SkeletonTableRows({ rows = 5, columns = 4 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r}>
          {Array.from({ length: columns }).map((_, c) => (
            <td key={c}>
              <SkeletonText width={c === 0 ? '70%' : '50%'} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

// Generic card-grid skeleton for dashboard-style metric tiles.
export function SkeletonCards({ count = 4 }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${count}, 1fr)`, gap: 'var(--space-4)' }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card card-panel">
          <SkeletonText width="60%" />
          <div style={{ marginTop: 12 }}>
            <SkeletonBlock height={28} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Skeleton({ variant = 'text', ...rest }) {
  if (variant === 'circle') return <SkeletonCircle {...rest} />;
  if (variant === 'block') return <SkeletonBlock {...rest} />;
  return <SkeletonText {...rest} />;
}
